// Clipboard utility with fallback mechanism
// Handles Permissions-Policy restrictions gracefully

export const copyToClipboard = async (text) => {
  // Method 1: Modern Clipboard API
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return { success: true, method: 'clipboard-api' };
    } catch (err) {
      console.log('Clipboard API failed, trying fallback:', err.message);
    }
  }

  // Method 2: execCommand fallback
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // Avoid scrolling to bottom
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    textArea.style.top = '0';
    textArea.style.opacity = '0';
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    
    if (successful) {
      return { success: true, method: 'execCommand' };
    }
  } catch (err) {
    console.log('execCommand fallback failed:', err.message);
  }

  // Method 3: Return failure - UI should show manual copy modal
  return { success: false, text };
};

// React hook for clipboard with toast notifications
export const useClipboard = (toastFn) => {
  const copy = async (text, successMessage = 'Copied to clipboard!') => {
    const result = await copyToClipboard(text);
    
    if (result.success) {
      toastFn?.success?.(successMessage);
      return true;
    } else {
      // Show manual copy fallback
      toastFn?.info?.('Please copy manually: Select the text and press Ctrl+C / Cmd+C');
      return false;
    }
  };

  return { copy };
};
